/*
 *		Copyright (c) 2011-2016 Acronis Incorporated. All rights reserved.
 *
 *	This source code may be used only by organizations licensed to use Acronis Access, in conjunction with normal Acronis Access usage.
 *	No portion of it may be redistributed or modified without the written permission of Acronis, Inc. See the Acronis Software License Agreement for more information.
 */

angular.module('access.DataTable')
    .factory('SearchService', [function() {
        return {
            searchState: {
                enabled: false, // is the search box enabled?
                string: '', // the string in the search box
                rootSearchString: '', // string to search if the user clicks Search in Sync & Share
                active: false, // true if currently displaying search results
                searching: false, // currently performing a search?
                nodeUuid: null,
                nodeName: '',
                numFound: null // number of results
            },
            setSearchState: function(active, currentNode) {
                this.searchState.active = active;
    
                if (active) {
                    this.searchState.nodeUuid = (currentNode && currentNode.uuid) || '0';
                    this.searchState.nodeName = (currentNode && currentNode.name) || '';
                }
            },
            search: function() {},
            resetSearch: function() {}
        }
    }]);
